import { configuratorBuilder } from 'awr-domain'

import { createConfiguratorInterface } from '@salsita-ai/platform-project-sdk/configurator'

export const configuratorInterface = createConfiguratorInterface(configuratorBuilder)
